import { io } from 'socket.io-client';

const params = new URLSearchParams(window.location.search);

const socket = io('/', {
    query: {
        name: params.get('name') || 'Anonymous',
        email: params.get('email') || 'anon@example.com',
        imageUrl: params.get('image') || '',
    },
});

export { socket };
